// src/hooks/useGoogleReviews.js

import { useState, useEffect } from "react";

export default function useGoogleReviews() {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(null);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const base = process.env.REACT_APP_API_BASE || "";
        const url = `${base}/api/reviews`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        setReviews(data.reviews || []);
        setRating(data.rating || 0);
        setTotal(data.totalReviews || 0);
      } catch (err) {
        console.error("Review fetch error:", err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { reviews, rating, total, loading };
}

